export default __webpack_public_path__ + "static/media/clock-thin.8d8675fd.svg";